/**
 *
 * SlackVerify
 *
 */
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import { makeSelectIsVerify, makeSelectError } from './selectors';
import { verifySlackStart } from './actions';
import reducer from './reducer';
import saga from './saga';
import queryString from 'query-string';
import {
  VerifyContainer,
  VerifyContent,
  VerifyHeaderWrapper,
  VerifyDivider,
  VerifyLogo,
} from './styled';
import logo from 'assets/img/brand/logo-full.png';
import routeTemplates from 'common/route-templates';
import { NOTIFICATION } from 'common/constants';
import triggerNotification from 'utils/triggerNotification';

export const SlackVerify = props => {
  useInjectReducer({ key: 'slackVerify', reducer });
  useInjectSaga({ key: 'slackVerify', saga });

  const { verifySlack, isVerify, error } = props;
  const verifyCode = queryString.parse(props.location.search).code;
  console.log('redirect url', window.location.href);
  let state, integrationKey;

  try {
    state = JSON.parse(decodeURIComponent(queryString.parse(props.location.search).state));
    integrationKey = state && state.integrationKey;
  } catch (e) {
    triggerNotification({
      title: 'Something went wrong. Please try again',
      type: NOTIFICATION.TYPE.ERROR,
    });
  }

  if (!verifyCode) {
    triggerNotification({
      title: 'Something went wrong. Please try again',
      type: NOTIFICATION.TYPE.ERROR,
    });
  }
  useEffect(() => {
    if (verifyCode && state) {
      verifySlack({ payload: { code: verifyCode, state: JSON.stringify(state), integrationKey } });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [verifyCode]);

  return (
    <>
      <Helmet>
        <title>ZoomInfo Chat | Verify Slack</title>
        <meta name="description" content="Verify your slack" />
      </Helmet>
      <VerifyContainer>
        <div className="d-flex justify-content-center p-5">
          <VerifyLogo src={logo} alt="zoominfo chat logo" />
        </div>
        <VerifyContent>
          {isVerify ? (
            <>
              <VerifyHeaderWrapper>Pending</VerifyHeaderWrapper>
              <VerifyDivider />
              <p>Verification Pending</p>
            </>
          ) : error ? (
            <>
              <VerifyHeaderWrapper>Failed</VerifyHeaderWrapper>
              <VerifyDivider />
              <p>Something went wrong while connecting Slack with ZoomInfo Chat</p>
            </>
          ) : (
            <>
              <VerifyHeaderWrapper>Successful</VerifyHeaderWrapper>
              <VerifyDivider />
              <p>Successfully connected your Slack with ZoomInfo Chat</p>
            </>
          )}
        </VerifyContent>
      </VerifyContainer>
    </>
  );
};
SlackVerify.propTypes = {
  verifySlack: PropTypes.func.isRequired,
  isVerify: PropTypes.bool,
};
export const mapStateToProps = (state, props) => {
  return createStructuredSelector({
    isVerify: makeSelectIsVerify(),
    error: makeSelectError(),
  });
};
export const mapDispatchToProps = dispatch => {
  return {
    verifySlack: ({ payload }) => dispatch(verifySlackStart({ payload })),
  };
};
const withConnect = connect(mapStateToProps, mapDispatchToProps);
export default compose(withRouter, withConnect)(SlackVerify);
